export const Embed = () => {
    return (
        <embed className="embed" src="https://db.thealphaproject.eu"></embed>
    )
}

